module.exports = __webpack_public_path__ + "static/img/12.565ff9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/12.png
// module id = eRSx
// module chunks = 35